import { ReactElement, useMemo } from 'react';

import { useEventHandler } from '../../../hooks/useEventHandler';
import { Nullable } from '../../../types';
import { ControlledSelect } from '../ControlledSelect';
import { ControlledSelectValue } from '../ControlledSelect/types/ControlledSelectOption';
import {
  TypeaheadComponent,
  TypeaheadComponentProps,
} from './types/typeaheadProps';

export const Typeahead: TypeaheadComponent = <IsMulti extends boolean = false>({
  name,
  onChange: _onChange,
  value,
  disabled,
  isMulti,
  hooks,
  groups,
  options,
  ...props
}: TypeaheadComponentProps<IsMulti>): ReactElement => {
  const onChange = useEventHandler(
    (newValue: Nullable<ControlledSelectValue<IsMulti>>) => {
      _onChange(newValue);
      hooks?.afterOnChange?.({
        name,
        value: newValue,
      });
    },
  );

  const controlledSelectOptionProps = useMemo(() => {
    if (groups) {
      return {
        groups,
      };
    }

    return {
      options,
    };
  }, [groups, options]);

  return (
    <ControlledSelect
      {...props}
      {...controlledSelectOptionProps}
      disabled={disabled}
      isMulti={isMulti}
      name={name}
      onChange={onChange}
      searchable
      value={value}
    />
  );
};

Typeahead.controlled = true;
Typeahead.displayName = 'Typeahead';
